import { defineStore } from 'pinia';

const BUTTON_TYPES = ['left', 'right'];

export const useTopbarStore = defineStore('topbar', {
  state: () => ({
    title: '',
    sub: false,
    left: [],
    right: []
  }),
  actions: {
    setSub(status) {
      this.sub = !!status;
    },
    setTitle(title = '') {
      this.title = title;
    },
    addButton(button) {
      const type = button?.type;
      if (BUTTON_TYPES.includes(type)) {
        this[type].push(button);
      }
    },
    clear() {
      this.title = '';
      this.left = [];
      this.right = [];
    }
  }
});
